import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

const ModernStatCard = ({
  title,
  value,
  icon: Icon,
  trend,
  trendValue,
  description,
  iconBgColor = 'bg-blue-500',
  className = '',
}) => {
  const isPositiveTrend = trend === 'up';

  return (
    <div className={`bg-white rounded-lg shadow-sm border border-gray-200 p-6 ${className}`}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <p className="mt-2 text-3xl font-bold text-gray-900">{value}</p>

          {(trend || description) && (
            <div className="mt-2 flex items-center space-x-2">
              {trend && (
                <span className={`inline-flex items-center text-sm font-medium ${
                  isPositiveTrend ? 'text-green-600' : 'text-red-600'
                }`}>
                  {isPositiveTrend ? (
                    <TrendingUp className="w-4 h-4 mr-1" />
                  ) : (
                    <TrendingDown className="w-4 h-4 mr-1" />
                  )}
                  {trendValue}
                </span>
              )}
              {description && (
                <span className="text-sm text-gray-600">{description}</span>
              )}
            </div>
          )}
        </div>

        {Icon && (
          <div className={`flex-shrink-0 w-12 h-12 rounded-lg ${iconBgColor} flex items-center justify-center`}>
            <Icon className="w-6 h-6 text-white" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ModernStatCard;
